import { render, staticRenderFns } from "./customer-control.vue?vue&type=template&id=1c1aefc4"
import script from "./customer-control.vue?vue&type=script&lang=js"
export * from "./customer-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports